<template>
  <v-form class="pt-1">
    <v-select
      v-model="selectedPhoneNumber"
      :items="phoneNumbers"
      item-text="label"
      item-value="value"
      label="Select phone number"
      outlined
      dense
      hide-details
    ></v-select>
    <div class="mt-4 flex items-center justify-between">
      <v-file-input
        class="w-1/2"
        show-size
        label="Upload customer audio file"
        truncate-length="15"
        @change="onCustomerVoiceFileChange"
      ></v-file-input>
      <v-file-input
        class="w-1/2"
        label="Upload agent audio file"
        show-size
        truncate-length="15"
        @change="onAgentVoiceFileChange"
      ></v-file-input>
    </div>
    <v-combobox
      v-model="selectedAgents"
      :items="agents"
      :loading="fetchingAgents"
      :search-input.sync="agentSearch"
      item-text="label"
      item-value="value"
      label="Select agents"
      placeholder="Start typing to Search"
      prepend-icon="mdi-account-multiple-check"
      hide-selected
      multiple
      persistent-hint
      small-chips
    ></v-combobox>
    <div class="flex items-center justify-between">
      <v-btn
        color="primary"
        text
        @click="onPrev"
      >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
         Go back
      </v-btn>
      <div>
        <v-btn text @click="onClose">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          @click="onContinue"
        >
          Continue
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import { debounce } from "@/utils/common";

export default {
  name: "WhatsappConfig",
  layout: "Workforce/default",
  data() {
    return {
      authData: this.$storage.getUniversal("token"),
      fetchingAgents: false,
      selectedAgents: [],
      search: "",
      agents: [],
      agentSearch: "",
      selectedPhoneNumber: "",
      customerVoiceFile: null,
      agentVoiceFile: null,
      phoneNumbers: []
    };
  },
  watch: {
    agentSearch: debounce(async function () {
      this.search = this.agentSearch;
    }, 800),
    search(agentName) {
      this.fetchAgents(agentName)
    }
  },
  methods: {
    onCustomerVoiceFileChange(file) {
      this.customerVoiceFile = file;
    },
    onAgentVoiceFileChange(file) {
      this.agentVoiceFile = file;
    },
    async fetchPhoneNumbers() {
      const orgData = JSON.parse(localStorage.getItem("orgData"));
      const { data } = await this.$axios.get(`/workforce/tele-caller/credentials?orgId=${orgData?.id}`, {
        headers: {
          Authorization: this.authData.access_token,
        },
      });

      this.phoneNumbers = data.data.filter(p => p.type === "predictive").map(phoneNo => ({ label: phoneNo.phoneNumber, value: phoneNo._id }))
    },
    async fetchAgents() {
      const params = {
        search: this.search
      };
      this.fetchingAgents = true;

      const response = await this.$axios.get("/workforce/v2/users", {
        headers: {
          Authorization: this.authData.access_token,
        },
        params,
      });
      this.fetchingAgents = false;

      this.agents = response.data?.users.map((a) => ({ label: `${a.firstName} ${a.lastName}`, value: a.mobile })) || [];
    },
    onPrev() {
      this.$emit('prev')
    },
    onContinue() {
      this.$emit('continue', { phoneNoId: this.selectedPhoneNumber, agents: this.selectedAgents.map(a => ({ name: a.label, phoneNo: a.value})) })
      this.$emit('selectVoiceFiles', { agent: this.agentVoiceFile, customer: this.customerVoiceFile })
    },
    onClose() {
      this.$emit('cancel')
    },
  },
  mounted() {
    this.fetchPhoneNumbers();
  }
};
</script>

<style scoped>
</style>
